import { AutomatedRuleActionType } from 'src/graphql/types/automatedRules'
import IconApplicant from 'src/icons/IconApplicant'
import IconBook from 'src/icons/IconBook'
import IconChecklist from 'src/icons/IconChecklist'
import IconClipboardList from 'src/icons/IconClipboardList'
import IconDocument from 'src/icons/IconDocument'
import IconEmail from 'src/icons/IconEmail'
import IconGraduationCap from 'src/icons/IconGraduationCap'
import IconMessage from 'src/icons/IconMessage'
import IconNote from 'src/icons/IconNote'
import IconPhone from 'src/icons/IconPhone'
import IconSwapArrows from 'src/icons/IconSwapArrows'
import IconUsers from 'src/icons/IconUsers'

import { ACTION_COLOR_MAP } from '../../utils/actionDisplay'

const ICON_CLASS = 'h-3 w-3 fill-none stroke-current'

const ACTION_TYPE_ICON: Record<string, () => JSX.Element> = {
  [AutomatedRuleActionType.SMS]: () => <IconMessage className={ICON_CLASS} />,
  [AutomatedRuleActionType.SEND_EMAIL]: () => (
    <IconEmail className={ICON_CLASS} />
  ),
  [AutomatedRuleActionType.SEND_VOICE_AGENT_CALL]: () => (
    <IconPhone className={ICON_CLASS} />
  ),
  [AutomatedRuleActionType.DOCUMENT_TEMPLATE_PACKAGE]: () => (
    <IconDocument className={ICON_CLASS} />
  ),
  [AutomatedRuleActionType.GENERATE_ORDER]: () => (
    <IconClipboardList className={ICON_CLASS} />
  ),
  [AutomatedRuleActionType.ASSIGN_TRAINING]: () => (
    <IconGraduationCap className={ICON_CLASS} />
  ),
  [AutomatedRuleActionType.ASSIGN_COURSE]: () => (
    <IconBook className={ICON_CLASS} />
  ),
  [AutomatedRuleActionType.SEND_TRAINING_REMINDER]: () => (
    <IconGraduationCap className={ICON_CLASS} />
  ),
  [AutomatedRuleActionType.CHANGE_APPLICANT_STATUS]: () => (
    <IconSwapArrows className={ICON_CLASS} />
  ),
  [AutomatedRuleActionType.REASSIGN_LEAD_EMPLOYEE]: () => (
    <IconApplicant className={ICON_CLASS} />
  ),
  [AutomatedRuleActionType.ADD_MEMBER_EMPLOYEE]: () => (
    <IconUsers className={ICON_CLASS} />
  ),
  [AutomatedRuleActionType.CREATE_TASK]: () => (
    <IconChecklist className={ICON_CLASS} />
  ),
  [AutomatedRuleActionType.ADD_NOTE]: () => <IconNote className={ICON_CLASS} />,
  [AutomatedRuleActionType.START_VOE_OUTREACH]: () => (
    <IconUsers className={ICON_CLASS} />
  ),
}

type ActionLike = {
  actionType: string
}

const ActionIconBadge = ({ action }: { action: ActionLike }) => {
  const renderIcon = ACTION_TYPE_ICON[action.actionType]
  const colors = ACTION_COLOR_MAP[action.actionType]

  const colorClasses = colors
    ? `${colors.bg} ${colors.border} ${colors.text}`
    : 'bg-doubleNickel-gray-50 border-doubleNickel-gray-200 text-doubleNickel-gray-700'

  return (
    <span
      className={`inline-flex h-[22px] w-[22px] items-center justify-center rounded-md border ${colorClasses}`}
    >
      {renderIcon ? renderIcon() : <IconChecklist className={ICON_CLASS} />}
    </span>
  )
}

export default ActionIconBadge
